import { render, staticRenderFns } from "./imgViewModal.vue?vue&type=template&id=82f72870"
import script from "./imgViewModal.vue?vue&type=script&lang=js"
export * from "./imgViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports